module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/banner/th-c8cfbf4c5c945f404656d69428db4c7c.jpg";